<template>
  <div class="section section--sales">
    <h2 class="section__title">Sales</h2>
    <div class="section__container">
      <div class="section__content">
        <div class="details"></div>
        <div class="info">
          <h3 class="info__title">About Sales</h3>
          <p>Quickly get all of your new sales labels to print with one click.</p>
        </div>
        <div class="controls">
          <a
           v-if="!jobStatus"
            class="control control--send"
            @click="getSaleLabelsLink"
            href="javascript:void(0)"
          >Get Download Link</a>
          <a
            v-if="saleLabelsUrl"
            class="control control--download"
            :href="saleLabelsUrl"
            target="_blank"
          >Download Labels</a>
          <div v-if="jobStatus && jobStatus.status" class="job-status">
            <p v-if="jobStatus.status.status === 'active'">
              Combining labels
              <progress></progress>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      jobId: null,
    };
  },
  computed: {
    jobStatus() {
      if (!this.jobId) {
        return null;
      }
      return this.$store.state.jobs[this.jobId];
    },
    saleLabelsUrl() {
      if (this.jobStatus && this.jobStatus.status && this.jobStatus.status.value) {
        return this.jobStatus.status.value;
      }
      return null;
    },
  },
  methods: {
    // async fetchSalesCount() {},
    async getSaleLabelsLink() {
      this.jobId = await this.$store.dispatch('getSaleLabels');
    },
  },
};
</script>
